module.exports = __webpack_public_path__ + "img/mail.8c32c68b.svg";